import { useRouter } from 'next/router';

export const useIsAccountPage = () => {
  const router = useRouter();

  return router.route === '/[locationSlug]/[merchantSlug]/[merchantId]/account';
};
